// src/components/auth/components/ImgOlslm/ImgOlslmQ1.tsx
import React from "react";
import { TreeSelect, Tooltip } from "antd";
import styled from "styled-components";
import { loginImages } from "../../constants/LoginImg";

const { TreeNode } = TreeSelect;

const ImagePreview = styled.img`
  max-width: 50px;
  max-height: 50px;
  border-radius: 4px;
  margin-right: 8px;
`;

interface ImageData {
  id: string; // e.g., "972.1.3400"
  index: number; // loginImages.images index
  group: string; // e.g., "1-10"
  number: number; // e.g., 1, 2, ...
}

const imageData: ImageData[] = [
  { id: "972.1.3400", index: 8, group: "1-10", number: 1 },
  { id: "973.2.3400", index: 9, group: "1-10", number: 2 },
  { id: "2070.3.3402", index: 10, group: "1-10", number: 3 },
  { id: "2802.4.3405", index: 11, group: "1-10", number: 4 },
  { id: "976.5.3400", index: 12, group: "1-10", number: 5 },
  { id: "977.6.3400", index: 13, group: "1-10", number: 6 },
  { id: "2073.6.3403", index: 14, group: "1-10", number: 6 },
  { id: "2074.7.3403", index: 15, group: "1-10", number: 7 },
  { id: "979.8.3400", index: 16, group: "1-10", number: 8 },
  { id: "980.9.3400", index: 17, group: "1-10", number: 9 },
  { id: "981.10.3400", index: 18, group: "1-10", number: 10 },
  { id: "982.11.3400", index: 19, group: "11-20", number: 11 },
  { id: "983.1.12.3400", index: 20, group: "11-20", number: 12 },
  { id: "1714.12.3402", index: 25, group: "11-20", number: 12 },
  { id: "984.1.13.3400", index: 21, group: "11-20", number: 13 },
  { id: "984.9.13.3400", index: 22, group: "11-20", number: 13 },
  { id: "985.9.14.3400", index: 23, group: "11-20", number: 14 },
  { id: "986.1.15.3400", index: 24, group: "11-20", number: 15 },
  { id: "987.1.16.3400", index: 26, group: "11-20", number: 16 },
  { id: "2448.2.16.3404", index: 27, group: "11-20", number: 16 },
  { id: "259.9.17.3398", index: 28, group: "11-20", number: 17 },
  { id: "988.9.17.3400", index: 30, group: "11-20", number: 17 },
  { id: "2084.1.17.3403.RWH", index: 31, group: "11-20", number: 17 },
  { id: "2449.1.17.3404", index: 29, group: "11-20", number: 17 },
  { id: "1720.1.18.3402", index: 33, group: "11-20", number: 18 },
  { id: "2450.1.18.3404", index: 32, group: "11-20", number: 18 },
  { id: "1721.1.19.3402", index: 34, group: "11-20", number: 19 },
  { id: "262.9.20.3398", index: 35, group: "11-20", number: 20 },
  { id: "626.9.20.3399", index: 51, group: "11-20", number: 20 },
  { id: "991.2.20.3400", index: 36, group: "11-20", number: 20 },
  { id: "2452.1.20.3404", index: 37, group: "11-20", number: 20 },
  { id: "992.1.21.3400", index: 38, group: "21-30", number: 21 },
  { id: "2453.1.21.3404", index: 39, group: "21-30", number: 21 },
  { id: "2454.1.22.3404", index: 40, group: "21-30", number: 22 },
  { id: "994.9.23.3400", index: 41, group: "21-30", number: 23 },
  { id: "2455.1.23.3404", index: 42, group: "21-30", number: 23 },
  { id: "630.9.24.3399", index: 43, group: "21-30", number: 24 },
  { id: "2456.1.24.3404", index: 44, group: "21-30", number: 24 },
  { id: "996.2.25.3400", index: 45, group: "21-30", number: 25 },
  { id: "996.9.25.3400", index: 46, group: "21-30", number: 25 },
  { id: "2092.1.25.3402", index: 47, group: "21-30", number: 25 },
  { id: "2457.1.25.3404", index: 48, group: "21-30", number: 25 },
  { id: "2093.1.26.3402", index: 49, group: "21-30", number: 26 },
  { id: "2458.1.26.3404", index: 50, group: "21-30", number: 26 },
  { id: "2094.1.27.3400", index: 53, group: "21-30", number: 27 },
  { id: "2459.1.27.3404", index: 52, group: "21-30", number: 27 },
  { id: "634.3.28.3399", index: 54, group: "21-30", number: 28 },
  { id: "2095.1.28.3403", index: 55, group: "21-30", number: 28 },
  { id: "2461.1.28.3404", index: 57, group: "21-30", number: 28 },
  { id: "635.1.29.3399", index: 58, group: "21-30", number: 29 },
  { id: "2096.1.29.3403", index: 56, group: "21-30", number: 29 },
  { id: "636.6.30.3399", index: 60, group: "21-30", number: 30 },
  { id: "1732.10.30.3402", index: 61, group: "21-30", number: 30 },
  { id: "2097.2.30.3403", index: 59, group: "21-30", number: 30 },
  { id: "2462.1.30.3404", index: 62, group: "21-30", number: 30 },
  { id: "637.2.31.3399", index: 63, group: "31-40", number: 31 },
  { id: "1733.1.31.3402", index: 64, group: "31-40", number: 31 },
  { id: "2463.1.31.3404", index: 65, group: "31-40", number: 31 },
  { id: "1734.1.32.3402", index: 66, group: "31-40", number: 32 },
  { id: "2099.1.32.3403", index: 67, group: "31-40", number: 32 },
  { id: "2464.1.32.3404", index: 68, group: "31-40", number: 32 },
  { id: "275.33.3398", index: 83, group: "31-40", number: 33 },
  { id: "639.1.33.3399", index: 69, group: "31-40", number: 33 },
  { id: "1004.9.33.3401", index: 72, group: "31-40", number: 33 },
  { id: "1735.1.33.3402", index: 70, group: "31-40", number: 33 },
  { id: "2100.1.33.3403", index: 71, group: "31-40", number: 33 },
  { id: "2456.1.33.3404", index: 73, group: "31-40", number: 33 },
  { id: "640.1.34.3399", index: 76, group: "31-40", number: 34 },
  { id: "1736.1.34.3402", index: 74, group: "31-40", number: 34 },
  { id: "2466.10.34.3404", index: 75, group: "31-40", number: 34 },
  { id: "641.1.35.3399", index: 77, group: "31-40", number: 35 },
  { id: "2102.1.35.3403", index: 78, group: "31-40", number: 35 },
  { id: "2467.1.35.3404", index: 79, group: "31-40", number: 35 },
  { id: "642.36.3399", index: 82, group: "31-40", number: 36 },
  { id: "2103.1.36.3403", index: 80, group: "31-40", number: 36 },
  { id: "2468.1.36.3404", index: 81, group: "31-40", number: 36 },
  { id: "643.1.37.3399", index: 84, group: "31-40", number: 37 },
  { id: "1008.9.37.3401", index: 88, group: "31-40", number: 37 },
  { id: "1739.1.37.3402", index: 85, group: "31-40", number: 37 },
  { id: "2104.37.3403", index: 86, group: "31-40", number: 37 },
  { id: "2469.10.37.3404", index: 87, group: "31-40", number: 37 },
  { id: "644.8.38.3399", index: 89, group: "31-40", number: 38 },
  { id: "1740.1.38.3402", index: 90, group: "31-40", number: 38 },
  { id: "2470.1.38.3404", index: 91, group: "31-40", number: 38 },
  { id: "645.8.39.3399", index: 92, group: "31-40", number: 39 },
  { id: "1010.1.39.3400", index: 94, group: "31-40", number: 39 },
  { id: "2471.1.39.3404", index: 93, group: "31-40", number: 39 },
  { id: "2472.1.40.3404", index: 95, group: "31-40", number: 40 },
  { id: "647.41.3399", index: 96, group: "41-50", number: 41 },
  { id: "2473.41.3404", index: 97, group: "41-50", number: 41 },
  { id: "1012.1.42.3400", index: 100, group: "41-50", number: 42 },
  { id: "1744.1.42.3402", index: 98, group: "41-50", number: 42 },
  { id: "2474.1.42.3404", index: 99, group: "41-50", number: 42 },
  { id: "650.1.44.3399", index: 102, group: "41-50", number: 44 },
  { id: "1015.1.44.107", index: 106, group: "41-50", number: 44 },
  { id: "1745.1.43.3402", index: 101, group: "41-50", number: 44 },
  { id: "1746.1.44.3402", index: 104, group: "41-50", number: 44 },
  { id: "2111.1.44.3403", index: 103, group: "41-50", number: 44 },
  { id: "2476.1.44.3404", index: 105, group: "41-50", number: 44 },
  { id: "651.2.45.3399", index: 107, group: "41-50", number: 45 },
  { id: "1016.1.45.3400", index: 108, group: "41-50", number: 45 },
  { id: "1747.1.45.3402", index: 109, group: "41-50", number: 45 },
  { id: "2477.1.45.3404", index: 110, group: "41-50", number: 45 },
  { id: "652.8.46.3399", index: 111, group: "41-50", number: 46 },
  { id: "1017.1.46.3400", index: 112, group: "41-50", number: 46 },
  { id: "2478.1.46.3404", index: 113, group: "41-50", number: 46 },
  { id: "653.1.47.3399(AA&RWH)", index: 114, group: "41-50", number: 47 },
  { id: "1018.1.47.3400", index: 115, group: "41-50", number: 47 },
  { id: "1749.1.47.3402", index: 116, group: "41-50", number: 47 },
  { id: "2479.1.47.3404", index: 117, group: "41-50", number: 47 },
  { id: "654.3.48.3399", index: 118, group: "41-50", number: 48 },
  { id: "1019.1.48.3400", index: 119, group: "41-50", number: 48 },
  { id: "1750.1.48.3402", index: 120, group: "41-50", number: 48 },
  { id: "2480.1.48.3404", index: 121, group: "41-50", number: 48 },
  { id: "1020.1.49.3400", index: 123, group: "41-50", number: 49 },
  { id: "1751.1.49.3402", index: 122, group: "41-50", number: 49 },
  { id: "2481.1.49.3402", index: 124, group: "41-50", number: 49 },
  { id: "656.3.50.3399", index: 125, group: "41-50", number: 50 },
  { id: "1021.50.3400", index: 126, group: "41-50", number: 50 },
  { id: "1752.1.50.3402", index: 127, group: "41-50", number: 50 },
  { id: "2482.1.50.3404", index: 128, group: "41-50", number: 50 },
  { id: "657.9.51.3399", index: 129, group: "51-60", number: 51 },
  { id: "1022.1.51.3400", index: 130, group: "51-60", number: 51 },
  { id: "1753.12.51.3402", index: 131, group: "51-60", number: 51 },
  { id: "2483.1.51.3404", index: 132, group: "51-60", number: 51 },
  { id: "658.9.52.3399", index: 133, group: "51-60", number: 52 },
  { id: "1023.1.52.3400", index: 134, group: "51-60", number: 52 },
  { id: "1754.1.52.3402", index: 135, group: "51-60", number: 52 },
  { id: "1024.1.53.3400", index: 136, group: "51-60", number: 53 },
  { id: "1390.1.53.3400", index: 139, group: "51-60", number: 53 },
  { id: "1755.1.53.3402", index: 137, group: "51-60", number: 53 },
  { id: "2120.1.53.3403", index: 138, group: "51-60", number: 53 },
  { id: "1391.9.54.3400", index: 140, group: "51-60", number: 54 },
  { id: "1756.1.54.3402", index: 141, group: "51-60", number: 54 },
  { id: "2121.1.54.3403", index: 142, group: "51-60", number: 54 },
  { id: "1392.10.55.3401", index: 143, group: "51-60", number: 55 },
  { id: "2122.1.55.3403", index: 144, group: "51-60", number: 55 },
  { id: "1027.1.56.3400", index: 146, group: "51-60", number: 56 },
  { id: "1758.1.56.3402", index: 145, group: "51-60", number: 56 },
  { id: "2123.1.56.3403", index: 147, group: "51-60", number: 56 },
  { id: "1028.1.57.3400", index: 148, group: "51-60", number: 57 },
  { id: "1759.1.57.3402", index: 149, group: "51-60", number: 57 },
  { id: "2124.1.57.3403", index: 150, group: "51-60", number: 57 },
  { id: "1029.1.58.3400", index: 152, group: "51-60", number: 58 },
  { id: "1395.1.58.3400", index: 151, group: "51-60", number: 58 },
  { id: "1760.1.58.3402", index: 153, group: "51-60", number: 58 },
  { id: "1030.1.59.3400", index: 154, group: "51-60", number: 59 },
  { id: "1761.1.59.3402", index: 155, group: "51-60", number: 59 },
  { id: "2126.1.59.3403", index: 156, group: "51-60", number: 59 },
  { id: "2491.1.59.3404", index: 157, group: "51-60", number: 59 },
  { id: "1031.1.60.3400", index: 158, group: "51-60", number: 60 },
  { id: "2492.1.60.3404", index: 159, group: "51-60", number: 60 },
  { id: "1032.61.3400", index: 160, group: "61-70", number: 61 },
  { id: "1398.61.3400", index: 161, group: "61-70", number: 61 },
  { id: "2128.61.3403", index: 163, group: "61-70", number: 61 },
  { id: "2493.61.3404", index: 162, group: "61-70", number: 61 },
  { id: "1033.1.62.3400", index: 164, group: "61-70", number: 62 },
  { id: "1399.1.62.3401", index: 165, group: "61-70", number: 62 },
  { id: "2494.1.62.3404", index: 166, group: "61-70", number: 62 },
  { id: "1400.1.63.3401", index: 168, group: "61-70", number: 63 },
  { id: "2130.1.63.3403", index: 167, group: "61-70", number: 63 },
  { id: "2495.1.63.3404", index: 169, group: "61-70", number: 63 },
  { id: "1766.1.64.3402", index: 170, group: "61-70", number: 64 },
  { id: "2131.1.64.3402", index: 171, group: "61-70", number: 64 },
  { id: "1036.1.65.3400", index: 172, group: "61-70", number: 65 },
  { id: "1767.1.65.3402", index: 173, group: "61-70", number: 65 },
  { id: "2132.1.65.3402", index: 174, group: "61-70", number: 65 },
  { id: "1037.1.66.3400", index: 175, group: "61-70", number: 66 },
  { id: "1768.1.66.3402", index: 176, group: "61-70", number: 66 },
  { id: "2133.1.66.3402", index: 177, group: "61-70", number: 66 },
  { id: "1038.1.67.3400", index: 178, group: "61-70", number: 67 },
  { id: "1404.1.67.3401", index: 179, group: "61-70", number: 67 },
  { id: "1769.1.67.3402", index: 180, group: "61-70", number: 67 },
  { id: "2499.1.67.3404", index: 181, group: "61-70", number: 67 },
  { id: "1039.1.68.3400", index: 182, group: "61-70", number: 68 },
  { id: "2135.1.68.3403", index: 183, group: "61-70", number: 68 },
  { id: "1771.1.69.3400", index: 184, group: "61-70", number: 69 },
  { id: "2136.1.69.3403", index: 185, group: "61-70", number: 69 },
  { id: "2501.10.69.3404", index: 186, group: "61-70", number: 69 },
  { id: "1772.1.70.3400", index: 187, group: "61-70", number: 70 },
  { id: "2137.1.70.3403", index: 188, group: "61-70", number: 70 },
  { id: "1042.1.71.3400", index: 189, group: "71-80", number: 71 },
  { id: "2138.1.71.3403", index: 190, group: "71-80", number: 71 },
  { id: "1043.1.72.3400", index: 191, group: "71-80", number: 72 },
  { id: "2139.1.72.3403", index: 192, group: "71-80", number: 72 },
  { id: "1044.1.73.3400", index: 193, group: "71-80", number: 73 },
  { id: "1410.1.73.3401", index: 194, group: "71-80", number: 73 },
  { id: "2140.1.73.3403", index: 195, group: "71-80", number: 73 },
  { id: "1045.1.74.3400", index: 196, group: "71-80", number: 74 },
  { id: "1776.1.74.3402", index: 197, group: "71-80", number: 74 },
  { id: "2141.1.74.3403", index: 198, group: "71-80", number: 74 },
  { id: "681.1.75.3399", index: 199, group: "71-80", number: 75 },
  { id: "1046.1.75.3400", index: 200, group: "71-80", number: 75 },
  { id: "1777.1.75.3402", index: 201, group: "71-80", number: 75 },
  { id: "2508.1.76.3404", index: 202, group: "71-80", number: 76 },
  { id: "683.1.77.3399", index: 203, group: "71-80", number: 77 },
  { id: "684.11.78.3399", index: 204, group: "71-80", number: 78 },
  { id: "685.11.79.3399", index: 205, group: "71-80", number: 79 },
  { id: "1781.1.79.3402", index: 206, group: "71-80", number: 79 },
  { id: "686.11.80.3399", index: 207, group: "71-80", number: 80 },
  { id: "1782.1.80.3402", index: 208, group: "71-80", number: 80 },
  { id: "2512.1.80.3404", index: 209, group: "71-80", number: 80 },
  { id: "1783.1.81.3402", index: 210, group: "81-90", number: 81 },
  { id: "2148.1.81.3403", index: 211, group: "81-90", number: 81 },
  { id: "688.1.82.3399", index: 212, group: "81-90", number: 82 },
  { id: "1419.11.82.3401", index: 213, group: "81-90", number: 82 },
  { id: "1784.1.82.3402", index: 214, group: "81-90", number: 82 },
  { id: "2150.1.83.3403", index: 215, group: "81-90", number: 83 },
  { id: "690.1.84.3399", index: 216, group: "81-90", number: 84 },
  { id: "691.2.85.3399", index: 217, group: "81-90", number: 85 },
  { id: "1787.1.85.3402", index: 218, group: "81-90", number: 85 },
  { id: "692.1.86.3399", index: 219, group: "81-90", number: 86 },
  // Add new images here, e.g.:
  // { id: "NEW_ID", index: 220, group: "91-100", number: 91 },
];

const ImgOlslmQ1: React.FC = () => {
  // Group images by 'group' and 'number'
  const groupedImages = imageData.reduce((acc, img) => {
    acc[img.group] = acc[img.group] || {};
    acc[img.group][img.number] = acc[img.group][img.number] || [];
    acc[img.group][img.number].push(img);
    return acc;
  }, {} as Record<string, Record<number, ImageData[]>>);

  const renderTreeNodes = () => (
    <TreeNode title="Q1" key="1-1-1" value="1-1-1" disabled aria-label="Q1 images">
      {Object.entries(groupedImages).map(([group, numbers]) => (
        <TreeNode
          title={group}
          key={`0-${group}`}
          value={`0-${group}`}
          disabled
          aria-label={`Image group ${group}`}
        >
          {Object.entries(numbers)
            .sort(([a], [b]) => Number(a) - Number(b))
            .map(([number, imgs]) => (
              <TreeNode
                title={number}
                key={`random0-${number}-${group}`}
                value={`random0-${number}-${group}`}
                disabled
                aria-label={`Image subgroup ${number}`}
              >
                {imgs.map((img, idx) => {
                  const image = loginImages.images[img.index];
                  return image ? (
                    <TreeNode
                      title={
                        <Tooltip title={img.id}>
                          <span>
                            <ImagePreview
                              src={image.url}
                              alt={`Image ${img.id}`}
                              onError={(e) => {
                                e.currentTarget.src = "https://via.placeholder.com/50";
                              }}
                            />
                            {img.id}
                          </span>
                        </Tooltip>
                      }
                      key={`image-${img.index}-${img.id}-${idx}`}
                      value={image.url}
                      imageUrl={image.url}
                      aria-label={`Image ${img.id}`}
                    />
                  ) : (
                    <TreeNode
                      title={`Missing image: ${img.id}`}
                      key={`missing-${img.id}-${idx}`}
                      value={`missing-${img.id}`}
                      disabled
                      aria-label={`Missing image ${img.id}`}
                    />
                  );
                })}
              </TreeNode>
            ))}
        </TreeNode>
      ))}
    </TreeNode>
  );

  return renderTreeNodes();
};

export default ImgOlslmQ1;